import { type SvgProps, SvgWrapper } from '../utils';

export function ArrowRightIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967L19.5303 11.4697C19.8232 11.7626 19.8232 12.2373 19.5303 12.5302L12.5303 19.5302C12.2374 19.8231 11.7626 19.8231 11.4697 19.5302C11.1768 19.2373 11.1768 18.7626 11.4697 18.4697L17.1895 12.7499H5C4.58579 12.7499 4.25 12.4142 4.25 11.9999C4.25 11.5857 4.58579 11.2499 5 11.2499H17.1895L11.4697 5.53022C11.1768 5.23732 11.1768 4.76256 11.4697 4.46967Z" />
    </SvgWrapper>
  );
}
